import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import AccessibleSlider from '../AccessibleSlider';

const SLIDER_SETTINGS = {
  dots: true,
  arrows: false,
  autoplaySpeed: 5000,
  adaptiveHeight: true,
  autoplay: true,
};

export default function ImageCarousel({ images, fit }) {
  return (
    <div className="image-carousel">
      <AccessibleSlider settings={SLIDER_SETTINGS}>
        {images.map((image, index) => (
          <GatsbyImage
            key={index}
            alt={image.title}
            image={image.gatsbyImageData}
            objectFit={fit}
          />
        ))}
      </AccessibleSlider>
    </div>
  );
}
